import { useState, useEffect } from "react";
import './index.less'
import { isWeChat, isWeChatMini } from '@/utils/common'
import wx from "weixin-js-sdk";

const CoachSettleAgreement = (props:any) => {
  const [isBottom, setIsBottom] = useState<boolean>(false)

  useEffect(() => {
    const dom = document.getElementsByClassName('coach-settle-agreement')[0]

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = dom;
      if (scrollTop + clientHeight >= scrollHeight - 1) setIsBottom(true)
    };

    dom.addEventListener('scroll', handleScroll);

    return () => {
      dom.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const agree = () => {
    wx.miniProgram.postMessage({
      data: { action: "handleClick", payload: '1' }
    });
    wx.miniProgram.navigateBack({ url: '/pages_h5/active-webview/index' }); 
    // onReturn()
  }

  return (
    <div className={'coach-settle-agreement' + ((isWeChat || isWeChatMini) ? ' wechat-agreement' : '')}>
      <p>本协议旨在明确小香风平台与教练之间的权利与义务，以确保双方在合作期间共同遵守法律法规和协议约定。</p>

      <h3>第一条 协议目的</h3>

      <p>本协议的目的是为了规范教练的管理，提高教练的教学水平，保障顾客的合法权益，以及维护小香风的声誉和社会形象。</p>

      <h3>第二条 小香风与教练之间的权利与义务</h3>

      <ul>
        <li>1、平台按协议约定支付教练订单费用；</li>
        <li>2、平台对教练的服务质量进行监督和管理；</li>
        <li>3、如发现教练有违反协议的行为，有权解除协议并要求赔偿。</li>
      </ul>

      <h3>第三条 教练的权利与义务</h3>

      <ul>
        <li>1、教练应具备相应的台球经验和服务质量，提供高质量的陪玩、教学服务；</li>
        <li>2、教练应保持仪容整洁、语言文明，不得有歧视、侮辱顾客的行为；</li>
        <li>3、教练应按照订单时间、地点按时赴约，不得迟到、违约；</li>
        <li>4、遵守小香风平台的各项管理制度；</li>
        <li>5、不得进行违法违纪行为，合法提供服务、自行申报个税等；</li>
        <li>6、如遇到顾客投诉,应及时沟通解决。</li>
      </ul>

      <h3>第四条 管理要求</h3>

      <ul>
        <li>1、禁止未成年人申请入驻教练；</li>
        <li>2、对于多次收到投诉的教练，小香风有权停用其接单权限，要求其进行整改或解除协议；</li>
        <li>3、对于违反协议规定的教练，小香风有权要求其赔偿损失并解除协议；</li>
        <li>4、教练不得诱导用户参与涉黄涉赌活动，如发现用户有违法违纪行为，教练及时制止并联系平台客服处理；</li>
        <li>5、本协议禁止任何形式的涉黄涉赌行为，包括但不限于组织、参与、宣传等，如发现有涉黄涉赌行为，小香风有权立即解除协议，包括但不限于并向相关部门举报、要求赔偿损失等；</li>
        <li>6、对于违反规定的教练，小香风有权将其纳入黑名单，并通报相关机构；</li>
        <li>7、本协议自教练人员同意本协议之日起生效；</li>
        <li>8、本协议未尽事宜，双方可协商解决。</li>
      </ul>

      {
        (isWeChat || isWeChatMini) ?
        <button disabled={!isBottom} onClick={() => agree()}>我已知晓并同意</button> : <></>
      }
    </div>
  )
}

export default CoachSettleAgreement